import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@adobe/react-spectrum';

const TaskContent = props => {
  const { task } = props;

  return (
    <>
      <div className="task-description">
        <h3>Description of Task</h3>
        <h4>{task.description ? task.description : 'No Description Found'}</h4>
        <Button marginStart="size-10">Creative Brief</Button>
      </div>
    </>
  );
};

TaskContent.propTypes = {
  task: {
    description: PropTypes.string.isRequired,
  },
};

TaskContent.defaultProps = {
  task: '',
};
export default TaskContent;
